import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export const ExpenseReviewCard = () => {
  const [s, setS] = useState(null);
  const nav = useNavigate();
  useEffect(() => { api.get("/expenses-review/summary").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s?.count) return null;
  return (
    <button type="button" onClick={() => nav("/app/expenses?filter=review")}
      className="w-full mb-6 flex items-center gap-3 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-left hover:border-rose-300 transition-colors"
      data-testid="expense-review-card">
      <AlertTriangle className="w-5 h-5 text-rose-600 shrink-0"/>
      <div className="flex-1 text-sm">
        <span className="font-semibold text-rose-900" data-testid="expense-review-count">{s.count} expense{s.count === 1 ? " needs" : "s need"} review</span>
        <span className="text-rose-700"> · ${s.total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} with missing or unsure details</span>
      </div>
      <ArrowRight className="w-4 h-4 text-rose-600"/>
    </button>
  );
};
